import React, { useEffect, useState } from "react";
import { IoMdArrowBack, IoMdClose } from "react-icons/io";
import { getAccessToken } from "../../../storage/storage";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { isVideoUrl, getVideoMimeType } from "../../../utils/mediaType";

const TaskSheetDetail = (props) => {
  const token = getAccessToken();
  const { id } = useParams();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { invoice, setShow } = props;
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  // Function to collect all media files from tasks
  const getAllMediaFiles = () => {
    if (!invoice?.tasks) return [];

    return invoice.tasks.reduce((acc, task) => {
      if (task.media_urls && task.media_urls.length > 0) {
        return [...acc, ...task.media_urls.map(url => ({
          url,
          taskName: task.task_name
        }))];
      }
      return acc;
    }, []);
  };

  const mediaFiles = getAllMediaFiles();

  const openPreview = (media) => {
    setSelectedMedia(media);
    setIsPreviewOpen(true);
    document.body.style.overflow = 'hidden'; // Prevent scrolling when modal is open
  };

  const closePreview = () => {
    setIsPreviewOpen(false);
    document.body.style.overflow = 'auto'; // Re-enable scrolling
  };

  return (
    <div>
      <div className="flex lg:flex-row flex-col lg:items-start items-center px-6 w-full ">
        <div className="flex lg:flex-row flex-col lg:items-start items-center px-6 w-full h-full">
          <div className="lg:px-10 px-4 mt-8 mb-16  w-full">
            <button
              onClick={() => setShow(false)}
              className="flex items-center gap-2 text-xl font-bold text-[#586989] hover:text-blue-600"
            >
              <IoMdArrowBack />
              <p>Back</p>
            </button>
            <div className="relative mt-4 pb-5">
              <div className="border border-[#DFDFDF] bg-white rounded-lg shadow-md overflow-auto max-h-[70vh] w-full">
                <table className="w-full border-collapse min-w-[600px]">
                  <thead className="sticky top-0 bg-[#FFF5CE] text-[#586989] z-10">
                    <tr>
                      <th className="border-gray-300 px-4 py-4">Clean Date</th>
                      <th className="border-gray-300 px-4 py-4">Task Name</th>
                      <th className="border-gray-300 px-4 py-2">Rate </th>
                      <th className="border-gray-300 px-4 py-2">Quantity </th>
                      <th className="border-gray-300 px-4 py-2">Total</th>
                    </tr>
                  </thead>

                  <tbody>
                    {invoice ? (
                      // Check if invoice has direct task properties
                      invoice.date &&
                        invoice.task_name &&
                        invoice.rate &&
                        invoice.quantity &&
                        invoice.total ? (
                        <tr className="border">
                          <td className="border border-gray-300 px-4 py-5 text-center">
                            {invoice.date || "-"}
                          </td>
                          <td className="border border-gray-300 px-4 py-5 text-center">
                            {invoice.task_name}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            {invoice.rate}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            {invoice.quantity}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            {invoice.total}
                          </td>
                        </tr>
                      ) : Array.isArray(invoice.tasks) &&
                        invoice.tasks.length > 0 ? (
                        invoice.tasks.map((task, index) => (
                          <tr key={index} className="border">
                            <td className="border border-gray-300 px-4 py-5 text-center">
                              {task.date || "—"}
                            </td>
                            <td className="border border-gray-300 px-4 py-5 text-center">
                              {task.task_name}
                            </td>
                            <td className="border border-gray-300 px-4 py-2 text-center">
                              {task.rate}
                            </td>
                            <td className="border border-gray-300 px-4 py-2 text-center">
                              {task.quantity}
                            </td>
                            <td className="border border-gray-300 px-4 py-2 text-center">
                              {task.total}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="7"
                            className="text-center py-5 text-gray-500"
                          >
                            No Task Sheet Found
                          </td>
                        </tr>
                      )
                    ) : (
                      <tr>
                        <td
                          colSpan="7"
                          className="text-center py-5 text-gray-500"
                        >
                          No Task Sheet Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            {/* <div className="flex items-start gap-3 p-4 bg-[#FFF5CE] rounded-lg border border-gray-300 shadow-sm">
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-[#586989]">
                  Comments
                </h3>
                <p className="text-gray-700 bg-white p-6 mt-3 rounded-lg border border-gray-300 shadow-sm">
                  {invoice?.comments || "No comments available"}
                </p>
              </div>
            </div> */}
            {/* Comments Section */}
            <div className="flex items-start gap-3 p-4 bg-[#FFF5CE] rounded-lg border border-gray-300 shadow-sm mt-8">
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-[#586989]">
                  Comments
                </h3>
                <div
                // "prose prose-sm leading-tight max-w-none bg-white p-6 mt-3 rounded-lg border border-gray-300 shadow-sm [&_p]:my-1 [&_li]:my-1"
                  className="prose max-w-none bg-white p-6 mt- rounded-lg border border-gray-300 shadow-sm"
                  dangerouslySetInnerHTML={{
                    __html: (invoice?.comments || "No comments available")
                      .replace(/\n/g, "<br />"),
                  }}
                />
                
              </div>
            </div>

            {/* Media Gallery Section */}
            {mediaFiles.length > 0 && (
              <div className="mt-6 ">
                <div className="flex items-start gap-3 p-4 ">
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold text-[#586989] mb-4">
                      Media Files
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                      {mediaFiles.map((media, index) => {
                        const isVideo = isVideoUrl(media.url);

                        return (
                          <div
                            key={index}
                            className="bg-white rounded-lg border border-[#DFDFDF] shadow-md overflow-hidden cursor-pointer hover:shadow-lg transition-shadow"
                            onClick={() => openPreview(media)}
                          >
                            <div className="p-3 bg-[#FFF5CE]">
                              <h4 className="font-medium text-[#586989]">
                                {media.taskName} ({isVideo ? 'Video' : 'Image'})
                              </h4>
                            </div>
                            <div className="p-2 flex justify-center items-center h-48">
                              {isVideo ? (
                                <video
                                  controls
                                  className="max-h-full max-w-full pointer-events-none"
                                >
                                  <source src={media.url} type={getVideoMimeType(media.url)} />
                                  Your browser does not support the video tag.
                                </video>
                              ) : (
                                <img
                                  src={media.url}
                                  alt={`Media for ${media.taskName}`}
                                  className="max-h-full max-w-full object-contain pointer-events-none"
                                />
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Media Preview Modal */}
      {isPreviewOpen && selectedMedia && (
        <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4">
          <button
            onClick={closePreview}
            className="absolute top-4 right-4 text-white text-3xl hover:text-gray-300 transition-colors"
          >
            <IoMdClose />
          </button>

          <div className="relative max-w-full max-h-full">
            {isVideoUrl(selectedMedia.url) ? (
              <video
                controls
                autoPlay
                className="max-h-[90vh] max-w-full"
              >
                <source src={selectedMedia.url} type={getVideoMimeType(selectedMedia.url)} />
                Your browser does not support the video tag.
              </video>
            ) : (
              <img
                src={selectedMedia.url}
                alt={`Preview of ${selectedMedia.taskName}`}
                className="max-h-[90vh] max-w-full object-contain"
              />
            )}
            <div className="text-white text-center mt-2">
              {selectedMedia.taskName}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TaskSheetDetail;